var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcesselement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 769,
    viewBox: "0 0 505 769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.266 229.054H398.238L398.266 229.019V229.054Z",
    fill: "url(#paint0_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.24 456.302V456.404L399.204 456.339L399.175 456.302L293.04 282.482L293.526 282.258L398.659 336.337L398.725 336.366L399.24 456.302Z",
    fill: "url(#paint1_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.173 229.019L398.238 229.055L398.173 229.091V229.019Z",
    fill: "url(#paint2_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M503.887 281.585L399.24 456.302L399.204 456.339L399.175 456.404V456.302L398.659 336.337L398.725 336.366L399.24 336.627L502.95 281.998L403.677 231.77L503.887 281.585Z",
    fill: "url(#paint3_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M502.95 281.997L399.24 336.627L398.725 336.366L398.659 336.337L293.526 282.258L398.173 229.091L398.238 229.055H398.267L403.677 231.77L502.95 281.997Z",
    fill: "url(#paint4_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.04 281.997L398.173 229.091L293.526 282.258L293.04 281.997Z",
    fill: "url(#paint5_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.677 231.77L398.267 229.055H398.238L398.267 229.019L403.677 231.77Z",
    fill: "url(#paint6_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.112 222.351C223.44 257.593 135.95 201.748 135.95 117.567V115.75C135.951 93.6846 142.297 72.0819 154.235 53.5025C166.173 34.9231 183.203 20.1459 203.307 10.9225C279.296 -23.8994 366.103 30.6717 367.337 114.049V115.866C367.671 138.199 361.496 160.148 349.563 179.05C337.63 197.952 320.451 212.994 300.112 222.351Z",
    fill: "url(#paint7_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M356.287 628.913L251.052 682.391V554.303L354.573 501.846L356.287 628.913Z",
    fill: "url(#paint8_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.824 628.913L251.052 682.391V554.303L147.531 501.846L145.824 628.913Z",
    fill: "url(#paint9_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M354.573 501.846L251.052 554.303L147.531 501.846L254.218 451.597L354.573 501.846Z",
    fill: "url(#paint10_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M321.915 732.156L251.052 768.063L180.196 732.156L253.216 697.761L321.915 732.156Z",
    fill: "url(#paint11_linear_154_1662)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.476 227.686H105.448L105.476 227.651V227.686Z",
    fill: "url(#paint12_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.45 454.934V455.028L106.421 454.963L106.385 454.934L0.25 281.114L0.736458 280.89L105.87 334.962L105.935 334.998L106.45 454.934Z",
    fill: "url(#paint13_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.383 227.651L105.448 227.687L105.383 227.716V227.651Z",
    fill: "url(#paint14_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.097 280.209L106.45 454.934L106.421 454.963L106.385 455.028V454.934L105.87 334.962L105.935 334.998L106.45 335.251L210.161 280.629L110.887 230.395L211.097 280.209Z",
    fill: "url(#paint15_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.16 280.629L106.45 335.251L105.935 334.998L105.87 334.962L0.73645 280.89L105.383 227.716L105.448 227.687H105.477L110.887 230.395L210.16 280.629Z",
    fill: "url(#paint16_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 280.629L105.383 227.716L0.736458 280.89L0.25 280.629Z",
    fill: "url(#paint17_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.887 230.394L105.478 227.687H105.448L105.478 227.651L110.887 230.394Z",
    fill: "url(#paint18_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M253.927 474.35L252.098 473.467L252.09 473.474L252.061 473.467V473.482L216.513 490.538L216.673 490.617L216.513 490.69L252.402 546.702V546.738L252.417 546.716L252.424 546.738V546.702L287.812 490.4L253.927 474.35Z",
    fill: "#006DE1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.746 309.146L198.043 331.696",
    stroke: "#006DE1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.606 309.761L304.599 330.951",
    stroke: "#006DE1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.811 251.049L164.702 245.474C168.765 243.398 173.239 242.244 177.802 242.096C182.365 241.949 186.905 242.811 191.094 244.62L240.764 266.092C244.641 267.768 248.823 268.633 253.049 268.633C257.275 268.633 261.456 267.768 265.334 266.092L315.01 244.62C319.199 242.812 323.738 241.951 328.3 242.1C332.862 242.249 337.334 243.404 341.395 245.482L352.286 251.056",
    stroke: "#006DE1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M323.498 587.091L324.377 555.078L308.512 582.588L289.351 573.379L287.812 629.174L303.684 601.664L322.837 610.865L323.222 596.915L320.354 603.047L308.469 597.53L315.177 583.218L323.498 587.091ZM300.083 593.773L294.122 590.993L296.91 585.028L302.892 587.808L300.083 593.773Z",
    fill: "#006DE1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M249.775 74.0027C250.826 73.7999 251.905 73.7999 252.956 74.0027C254.119 74.2848 255.236 74.7309 256.274 75.3275L256.528 75.4651L296.221 95.9455C296.805 96.2508 297.295 96.7088 297.637 97.2704C297.983 97.8294 298.164 98.4741 298.16 99.1309V136.928C298.241 138.319 298.091 139.713 297.717 141.055C297.319 142.219 296.672 143.283 295.822 144.175C294.799 145.126 293.627 145.904 292.351 146.477L292.047 146.636L253.021 166.769C252.51 167.036 251.942 167.175 251.366 167.175C250.789 167.175 250.221 167.036 249.71 166.769L210.721 146.636L210.416 146.477C209.141 145.904 207.968 145.126 206.945 144.175C206.095 143.283 205.449 142.219 205.05 141.055C204.673 139.713 204.524 138.319 204.607 136.928V99.1454C204.603 98.4886 204.785 97.8439 205.13 97.2848C205.473 96.7232 205.962 96.2653 206.546 95.96L246.24 75.4795L246.494 75.3492C247.517 74.7451 248.622 74.2916 249.775 74.0027ZM250.865 81.1625C250.407 81.3797 249.957 81.6041 249.507 81.8358L216.174 99.044L251.38 116.216L286.572 99.044L253.217 81.8358C252.777 81.6041 252.326 81.3797 251.867 81.1625L251.583 81.0467M247.75 157.684V122.449L211.752 104.886V136.588C211.752 137.486 211.752 137.992 211.752 138.383V138.753C211.815 138.92 211.908 139.075 212.028 139.209C212.124 139.284 212.226 139.352 212.333 139.411C212.659 139.614 213.117 139.846 213.908 140.251L247.75 157.684Z",
    fill: "#006DE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M397.912 299.459C419.413 299.459 436.843 294.377 436.843 288.108C436.843 281.838 419.413 276.756 397.912 276.756C376.411 276.756 358.98 281.838 358.98 288.108C358.98 294.377 376.411 299.459 397.912 299.459Z",
    fill: "#006DE1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M418.459 283.228C385.953 298.163 348.866 274.49 348.866 238.807V238.032C348.867 228.674 351.558 219.513 356.622 211.634C361.686 203.756 368.91 197.491 377.437 193.582C409.645 178.82 446.412 201.958 446.971 237.301V238.076C447.113 247.546 444.494 256.854 439.433 264.869C434.372 272.884 427.086 279.262 418.459 283.228Z",
    fill: "url(#paint19_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M404.853 239.531C404.576 239.531 404.301 239.484 404.039 239.393C403.542 239.235 403.108 238.922 402.802 238.5C402.496 238.077 402.335 237.568 402.341 237.048V233.949C401.107 233.75 399.984 233.12 399.173 232.172C398.361 231.224 397.914 230.019 397.912 228.773V221.591C397.912 220.201 398.465 218.868 399.451 217.885C400.437 216.902 401.774 216.35 403.168 216.35H415.889C416.582 216.345 417.27 216.477 417.912 216.739C418.553 217 419.137 217.385 419.629 217.872C420.121 218.359 420.512 218.939 420.778 219.577C421.045 220.215 421.182 220.9 421.182 221.591V228.758C421.182 230.149 420.628 231.482 419.642 232.465C418.656 233.448 417.319 234 415.925 234H410.262L406.857 238.517C406.628 238.834 406.327 239.091 405.978 239.267C405.63 239.443 405.244 239.534 404.853 239.531ZM389.061 242.289C387.42 242.289 385.815 241.804 384.45 240.894C383.086 239.985 382.022 238.693 381.394 237.181C380.766 235.669 380.601 234.005 380.922 232.4C381.242 230.795 382.032 229.32 383.193 228.163C384.353 227.006 385.832 226.218 387.442 225.899C389.052 225.579 390.72 225.743 392.237 226.369C393.753 226.996 395.049 228.056 395.961 229.417C396.873 230.778 397.36 232.378 397.36 234.014C397.36 235.101 397.145 236.177 396.728 237.181C396.311 238.185 395.7 239.097 394.929 239.865C394.158 240.634 393.244 241.243 392.237 241.659C391.23 242.075 390.151 242.289 389.061 242.289ZM374.714 250.332C374.714 250.426 374.881 260.467 389.097 260.467C403.313 260.467 403.48 250.404 403.48 250.332V249.181C403.48 248.085 403.044 247.033 402.266 246.258C401.489 245.483 400.434 245.047 399.335 245.047H378.831C377.731 245.047 376.675 245.483 375.897 246.258C375.118 247.033 374.68 248.084 374.678 249.181L374.714 250.332Z",
    fill: "#006DE1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M105.884 299.459C127.385 299.459 144.815 294.377 144.815 288.108C144.815 281.838 127.385 276.756 105.884 276.756C84.383 276.756 66.9529 281.838 66.9529 288.108C66.9529 294.377 84.383 299.459 105.884 299.459Z",
    fill: "#006DE1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.403 283.228C93.897 298.163 56.8099 274.49 56.8099 238.807V238.032C56.8086 228.675 59.4988 219.514 64.5615 211.635C69.6242 203.757 76.8469 197.491 85.373 193.582C117.588 178.82 154.392 201.958 154.915 237.301V238.076C155.056 247.546 152.437 256.853 147.375 264.869C142.314 272.884 135.028 279.261 126.403 283.228Z",
    fill: "url(#paint20_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.788 246.256C94.0321 246.013 94.3219 245.82 94.6408 245.688C94.9597 245.556 95.3015 245.489 95.6467 245.489H96.3728C96.5755 245.489 96.7704 245.411 96.9173 245.272C97.0602 245.13 97.1453 244.94 97.156 244.74C97.1667 244.539 97.1024 244.342 96.9754 244.186C94.1588 240.635 92.8095 236.144 93.2035 231.634C93.5976 227.124 95.7052 222.934 99.0952 219.922C102.485 216.91 106.901 215.303 111.44 215.43C115.979 215.558 120.298 217.41 123.512 220.607C126.727 223.805 128.595 228.106 128.734 232.631C128.873 237.157 127.272 241.564 124.26 244.952C121.247 248.339 117.05 250.451 112.528 250.855C108.005 251.259 103.499 249.925 99.9304 247.125C99.7724 247.001 99.5742 246.939 99.3735 246.951C99.1727 246.963 98.9833 247.048 98.8413 247.19C98.7017 247.337 98.6237 247.531 98.6235 247.733V248.457C98.6238 248.802 98.5553 249.143 98.4219 249.462C98.2885 249.78 98.093 250.068 97.8466 250.31L87.0284 261.075C86.4686 261.488 85.7789 261.686 85.0849 261.634C84.3908 261.582 83.7385 261.284 83.2468 260.792C82.755 260.301 82.4566 259.65 82.4057 258.958C82.3549 258.266 82.555 257.579 82.9697 257.021L93.788 246.256ZM110.908 245.482C113.334 245.482 115.705 244.764 117.721 243.421C119.738 242.077 121.31 240.168 122.238 237.933C123.166 235.699 123.409 233.241 122.936 230.869C122.463 228.497 121.295 226.318 119.58 224.608C117.865 222.898 115.68 221.733 113.301 221.262C110.922 220.79 108.456 221.032 106.216 221.957C103.975 222.883 102.06 224.45 100.712 226.461C99.3645 228.472 98.6453 230.836 98.6453 233.254C98.6424 234.861 98.9577 236.452 99.5729 237.937C100.188 239.422 101.091 240.771 102.231 241.907C103.37 243.043 104.723 243.943 106.212 244.557C107.701 245.17 109.297 245.484 110.908 245.482Z",
    fill: "#006DE1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M211.504 620.335C205.559 619.546 199.848 617.521 194.739 614.391C183.791 607.657 175.659 597.198 171.846 584.948C170.087 579.22 169.556 573.187 170.285 567.24L170.663 564.344L187.101 566.437L187.892 580.669L178.933 587.648C179.717 589.57 180.639 591.433 181.692 593.223C182.72 594.994 183.877 596.688 185.155 598.29C186.368 599.845 187.68 601.32 189.083 602.706C190.574 604.174 192.16 605.543 193.831 606.804L202.943 599.774L216.513 604.386L214.43 620.711L211.504 620.335Z",
    fill: "#006DE1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M203.176 254.299C205.281 254.299 206.988 252.598 206.988 250.498C206.988 248.399 205.281 246.698 203.176 246.698C201.071 246.698 199.364 248.399 199.364 250.498C199.364 252.598 201.071 254.299 203.176 254.299Z",
    fill: "#006DE1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.103 324.225C327.208 324.225 328.914 322.524 328.914 320.425C328.914 318.326 327.208 316.624 325.103 316.624C322.997 316.624 321.291 318.326 321.291 320.425C321.291 322.524 322.997 324.225 325.103 324.225Z",
    fill: "#006DE1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.45 458.735C108.556 458.735 110.262 457.033 110.262 454.934C110.262 452.835 108.556 451.133 106.45 451.133C104.345 451.133 102.639 452.835 102.639 454.934C102.639 457.033 104.345 458.735 106.45 458.735Z",
    fill: "#006DE1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M145.824 577.057C147.93 577.057 149.636 575.355 149.636 573.256C149.636 571.157 147.93 569.455 145.824 569.455C143.719 569.455 142.013 571.157 142.013 573.256C142.013 575.355 143.719 577.057 145.824 577.057Z",
    fill: "#006DE1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M397.912 460.204C400.017 460.204 401.723 458.503 401.723 456.404C401.723 454.305 400.017 452.603 397.912 452.603C395.806 452.603 394.1 454.305 394.1 456.404C394.1 458.503 395.806 460.204 397.912 460.204Z",
    fill: "#006DE1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M356.28 575.768C358.385 575.768 360.091 574.067 360.091 571.967C360.091 569.868 358.385 568.167 356.28 568.167C354.174 568.167 352.468 569.868 352.468 571.967C352.468 574.067 354.174 575.768 356.28 575.768Z",
    fill: "#006DE1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M283.95 261.459C286.055 261.459 287.761 259.757 287.761 257.658C287.761 255.559 286.055 253.858 283.95 253.858C281.844 253.858 280.138 255.559 280.138 257.658C280.138 259.757 281.844 261.459 283.95 261.459Z",
    fill: "#006DE1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M169.015 318.419C171.12 318.419 172.827 316.718 172.827 314.619C172.827 312.52 171.12 310.818 169.015 310.818C166.91 310.818 165.203 312.52 165.203 314.619C165.203 316.718 166.91 318.419 169.015 318.419Z",
    fill: "#006DE1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.825 572.706L120.863 561.347C116.253 559.255 112.353 555.872 109.636 551.61C106.918 547.348 105.502 542.391 105.557 537.341L106.385 454.934",
    stroke: "#006DE1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M354.573 572.706L375.106 564.359C382.224 561.462 388.303 556.498 392.554 550.111C396.805 543.724 399.031 536.21 398.943 528.545L398.13 456.404",
    stroke: "#006DE1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M252.074 305.387H252.047L252.074 305.352V305.387Z",
    fill: "url(#paint21_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M253.049 532.636V532.73L253.02 532.672L252.983 532.636L146.848 358.816L147.335 358.591L252.468 412.67L252.533 412.699L253.049 532.636Z",
    fill: "url(#paint22_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M251.981 305.352L252.047 305.388L251.981 305.417V305.352Z",
    fill: "url(#paint23_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M357.695 357.911L253.049 532.635L253.02 532.672L252.983 532.729V532.635L252.468 412.67L252.533 412.699L253.049 412.96L356.759 358.33L257.485 308.096L357.695 357.911Z",
    fill: "url(#paint24_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M356.759 358.33L253.049 412.96L252.533 412.699L252.468 412.67L147.335 358.591L251.981 305.417L252.047 305.388H252.076L257.485 308.096L356.759 358.33Z",
    fill: "url(#paint25_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M146.848 358.331L251.981 305.417L147.335 358.591L146.848 358.331Z",
    fill: "url(#paint26_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.485 308.096L252.076 305.388H252.047L252.076 305.352L257.485 308.096Z",
    fill: "url(#paint27_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M251.321 371.854C272.822 371.854 290.252 366.772 290.252 360.502C290.252 354.233 272.822 349.151 251.321 349.151C229.819 349.151 212.389 354.233 212.389 360.502C212.389 366.772 229.819 371.854 251.321 371.854Z",
    fill: "#006DE1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M271.861 355.623C239.355 370.558 202.261 346.885 202.261 311.201V310.42C202.263 301.063 204.955 291.903 210.019 284.026C215.083 276.149 222.306 269.885 230.831 265.976C263.046 251.215 299.843 274.353 300.373 309.696V310.47C300.515 319.941 297.896 329.249 292.835 337.264C287.773 345.279 280.487 351.657 271.861 355.623Z",
    fill: "url(#paint28_linear_154_1662)",
    stroke: "#006DE1",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M263.671 323.248C264.033 322.9 264.518 322.707 265.021 322.712C265.523 322.714 266.004 322.915 266.357 323.27C266.711 323.626 266.91 324.107 266.91 324.609C266.91 325.111 266.711 325.592 266.357 325.948L263.453 328.844C262.896 329.394 262.238 329.832 261.514 330.133C260.788 330.434 260.01 330.589 259.224 330.589C258.437 330.589 257.659 330.434 256.933 330.133C256.209 329.834 255.55 329.396 254.994 328.844C254.788 328.638 254.541 328.478 254.268 328.374C254.007 328.27 253.729 328.216 253.448 328.214C253.167 328.215 252.888 328.269 252.627 328.374C252.355 328.478 252.108 328.638 251.901 328.844L250.943 329.8C250.763 329.98 250.552 330.125 250.319 330.227C249.852 330.412 249.333 330.412 248.867 330.227C248.631 330.129 248.416 329.987 248.235 329.807C248.057 329.626 247.916 329.412 247.821 329.177C247.724 328.948 247.675 328.702 247.676 328.453C247.681 328.204 247.732 327.959 247.828 327.729C247.929 327.496 248.077 327.287 248.264 327.114L249.215 326.158C249.771 325.602 250.433 325.162 251.161 324.862C251.886 324.561 252.663 324.406 253.448 324.406C254.233 324.406 255.01 324.561 255.735 324.862C256.462 325.159 257.122 325.6 257.674 326.158C257.883 326.358 258.13 326.515 258.4 326.622C258.659 326.731 258.938 326.787 259.22 326.788C259.504 326.787 259.785 326.73 260.048 326.622C260.317 326.515 260.564 326.358 260.774 326.158L263.671 323.248ZM260.208 297.823C261.105 296.932 262.321 296.432 263.587 296.432C264.854 296.432 266.069 296.932 266.967 297.823C267.862 298.717 268.365 299.929 268.365 301.193C268.365 302.457 267.862 303.668 266.967 304.563L244.793 326.672C244.448 327.015 244.021 327.265 243.552 327.396L238.114 328.938C237.783 329.029 237.435 329.029 237.104 328.938C236.775 328.856 236.473 328.686 236.233 328.446C235.993 328.202 235.82 327.9 235.732 327.57C235.642 327.243 235.642 326.898 235.732 326.571L237.279 321.149C237.412 320.679 237.661 320.251 238.005 319.903L260.208 297.823ZM240.125 292.125C240.523 292.125 240.912 292.249 241.236 292.48C241.573 292.705 241.828 293.032 241.962 293.414L242.209 294.138C242.494 294.966 242.965 295.719 243.587 296.337C244.209 296.956 244.964 297.424 245.795 297.707L246.521 297.961C246.901 298.097 247.226 298.35 247.451 298.684C247.618 298.926 247.728 299.203 247.771 299.493C247.815 299.784 247.791 300.081 247.701 300.36C247.611 300.64 247.458 300.896 247.253 301.107C247.049 301.319 246.798 301.481 246.521 301.58L245.795 301.826C244.964 302.108 244.209 302.576 243.589 303.195C242.968 303.814 242.498 304.567 242.216 305.395L241.962 306.119C241.833 306.498 241.589 306.826 241.263 307.059C240.938 307.291 240.547 307.417 240.147 307.417C239.746 307.417 239.356 307.291 239.03 307.059C238.704 306.826 238.46 306.498 238.331 306.119L238.085 305.395C237.803 304.567 237.333 303.814 236.712 303.195C236.092 302.576 235.336 302.108 234.505 301.826L233.779 301.58C233.398 301.443 233.07 301.19 232.842 300.856C232.606 300.535 232.479 300.147 232.479 299.749C232.479 299.35 232.606 298.962 232.842 298.641C233.07 298.307 233.398 298.054 233.779 297.917L234.505 297.671C235.336 297.389 236.091 296.921 236.712 296.302C237.332 295.683 237.802 294.93 238.085 294.102L238.331 293.378C238.471 292.999 238.724 292.673 239.057 292.444C239.374 292.236 239.745 292.125 240.125 292.125Z",
    fill: "#006DE1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_1662",
    x1: 398.238,
    y1: 229.04,
    x2: 398.266,
    y2: 229.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_1662",
    x1: 293.04,
    y1: 369.327,
    x2: 399.24,
    y2: 369.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_1662",
    x1: 398.173,
    y1: 229.055,
    x2: 398.238,
    y2: 229.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_1662",
    x1: 398.659,
    y1: 344.083,
    x2: 503.887,
    y2: 344.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_1662",
    x1: 293.526,
    y1: 282.837,
    x2: 502.95,
    y2: 282.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_1662",
    x1: 293.04,
    y1: 255.675,
    x2: 398.173,
    y2: 255.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_154_1662",
    x1: 398.238,
    y1: 230.395,
    x2: 403.677,
    y2: 230.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_154_1662",
    x1: 135.921,
    y1: 116.67,
    x2: 367.381,
    y2: 116.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_154_1662",
    x1: 303.669,
    y1: 682.391,
    x2: 303.669,
    y2: 501.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_154_1662",
    x1: 224.725,
    y1: 537.732,
    x2: 174.1,
    y2: 646.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_154_1662",
    x1: 230.904,
    y1: 544.935,
    x2: 270.726,
    y2: 459.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_154_1662",
    x1: 251.052,
    y1: 697.761,
    x2: 251.052,
    y2: 768.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_154_1662",
    x1: 105.448,
    y1: 227.665,
    x2: 105.476,
    y2: 227.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_154_1662",
    x1: 0.25,
    y1: 367.959,
    x2: 106.45,
    y2: 367.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_154_1662",
    x1: 105.383,
    y1: 227.68,
    x2: 105.448,
    y2: 227.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_154_1662",
    x1: 105.87,
    y1: 342.715,
    x2: 211.097,
    y2: 342.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_154_1662",
    x1: 0.73645,
    y1: 281.469,
    x2: 210.16,
    y2: 281.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_154_1662",
    x1: 0.25,
    y1: 254.299,
    x2: 105.383,
    y2: 254.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_154_1662",
    x1: 105.448,
    y1: 229.026,
    x2: 110.887,
    y2: 229.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_154_1662",
    x1: 348.852,
    y1: 238.423,
    x2: 446.979,
    y2: 238.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_154_1662",
    x1: 56.8245,
    y1: 238.423,
    x2: 154.944,
    y2: 238.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_154_1662",
    x1: 252.047,
    y1: 305.373,
    x2: 252.074,
    y2: 305.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_154_1662",
    x1: 146.848,
    y1: 445.66,
    x2: 253.049,
    y2: 445.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_154_1662",
    x1: 251.981,
    y1: 305.388,
    x2: 252.047,
    y2: 305.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_154_1662",
    x1: 252.468,
    y1: 420.416,
    x2: 357.695,
    y2: 420.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_154_1662",
    x1: 147.335,
    y1: 359.17,
    x2: 356.759,
    y2: 359.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_154_1662",
    x1: 146.848,
    y1: 332.008,
    x2: 251.981,
    y2: 332.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_154_1662",
    x1: 252.047,
    y1: 306.728,
    x2: 257.485,
    y2: 306.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_154_1662",
    x1: 202.254,
    y1: 310.818,
    x2: 300.38,
    y2: 310.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesselement);
export default __webpack_public_path__ + "static/media/processelement.043e0b10ca4e9b0b6e015cf8297d44f9.svg";
export { ForwardRef as ReactComponent };